export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
// export const API_BASE_URL = 'http://192.168.1.207:5180'
// export const API_BASE_URL = 'http://192.168.1.107:5180'
// export const API_BASE_URL = 'http://192.168.1.64:5180'
// export const API_BASE_URL = 'http://localhost:5180'

export const themeVariables = {
  // brand
  brand: '--brand',
  onBrand: '--on-brand',

  // backgrounds / surfaces / borders
  bg: '--bg',
  surface: '--surface',
  surface2: '--surface-2',
  border: '--border',

  // text
  text: '--text',
  textMuted: '--text-muted',

  // system
  focus: '--focus',
  disabledBg: '--disabled-bg',
  disabledText: '--disabled-text',

  // semantic
  info: '--info',
  onInfo: '--on-info',
  success: '--success',
  onSuccess: '--on-success',
  warning: '--warning',
  onWarning: '--on-warning',
  error: '--error',
  onError: '--on-error',

  // logos
  logoBg: '--logo-bg',
  logoPrimary: '--logo-primary', // optional if you ever want to store urls in css vars
  logoSecondary: '--logo-secondary',

  // myMonitoring
  mmBrand: '--mm-brand',
  mmBrand2: '--mm-brand-2'
} as const

export type THEME_VARIABLES_TYPE = keyof typeof themeVariables
